var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('#### #### #### #### ####'),expression:"'#### #### #### #### ####'"},{name:"validate",rawName:"v-validate",value:('required|regex:^4081 7810 [0-9]{4} [0-9]{4} [0-9]{4}$'),expression:"'required|regex:^4081 7810 [0-9]{4} [0-9]{4} [0-9]{4}$'"}],attrs:{"label":_vm.required ? `${_vm.label}*` : _vm.label,"placeholder":"4081 7810 1234 5678 9012","value":_vm.value,"name":"account_number","danger":_vm.errors.has(_vm.errorsScope),"danger-text":(
      _vm.value &&
      _vm.value.length == 24 &&
      !_vm.value.startsWith('4081 7')
    )
    ? 'Чаевые нельзя отправить на ИП или ООО, введите номер счета физического лица'
    : 'Номер счета должен начинаться с 4081 7810 и содержать не менее 20 цифр'}},'vs-input',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }